
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarConeDown as ObiBuoyPilarConeDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-cone-down.js';
 
 
 

 
 export const ObiBuoyPilarConeDown = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-cone-down',
   elementClass: ObiBuoyPilarConeDownElement,
   events: {
     
   }
  });
 
 